var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"errorDiv"},[_c('van-icon',{attrs:{"name":"clear","size":"70","color":"red"}}),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('span',{staticStyle:{"color":"rgb(64, 158, 255)"}},[_vm._v(_vm._s(_vm.message))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }